module.exports = __webpack_public_path__ + "6b6f210225966e14fb4b66495831febb.svg";